export enum historyTypes {
    DOWNLOAD = 'download',
}